export default "__VITE_ASSET__B49V8U4L__"